import { Component, computed, inject, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { BillFolderBackendService } from '@core/providers/backend/bill-folder-backend.service';
import { DefaultAvatarComponent } from '@shared/components/default-avatar/default-avatar.component';

@Component({
  selector: 'app-profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe, DefaultAvatarComponent],
})
export class ProfilePictureComponent {
  private readonly billFolderBackendService = inject(BillFolderBackendService);

  readonly pictureUuid = input<string | null | undefined>(null);
  readonly size = input<number>(24);

  /** Optional explicit alt text (e.g. user name). Also names the stand-in tile. */
  readonly alt = input<string | null | undefined>(null);
  /** Translation key used when `alt` is not provided. */
  readonly altTranslationKey = input<string>('SHARED.SYSTEM.AVATAR_ALT');

  readonly src = computed(() => {
    const uuid = this.pictureUuid();
    if (!uuid) {
      return '';
    }

    const size = this.size();

    return this.billFolderBackendService.getFileUrl(uuid, size, size);
  });

  /** Keyed by URL, so a new picture gets its own attempt rather than inheriting a failure. */
  protected readonly failedSrc = signal<string | null>(null);

  protected readonly showPicture = computed(() => !!this.src() && this.src() !== this.failedSrc());
}
